import { render } from "./DaskControl.vue?vue&type=template&id=dc223502&scoped=true"
import script from "./DaskControl.vue?vue&type=script&lang=js"
export * from "./DaskControl.vue?vue&type=script&lang=js"

import "./DaskControl.vue?vue&type=style&index=0&id=dc223502&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc223502"]])

export default __exports__